import { render, staticRenderFns } from "./Short_form_SchoolComparison.vue?vue&type=template&id=9a125b80&scoped=true&"
import script from "./Short_form_SchoolComparison.vue?vue&type=script&lang=js&"
export * from "./Short_form_SchoolComparison.vue?vue&type=script&lang=js&"
import style0 from "./Short_form_SchoolComparison.vue?vue&type=style&index=0&id=9a125b80&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a125b80",
  null
  
)

export default component.exports